import { getCurrentInstance } from 'vue';

export function useAnalytics() {
  return getCurrentInstance()?.appContext.config.globalProperties.$analytics;
}
